<template>
    <!-- 人体成分 -->
    <div style="width: 611px;">
        <!-- 表格 -->
        <div class="tabel-box" style="margin-top: 4px;">
            <div style="width: 112px; text-align: left; ">
                <div class="left-item"></div>
                <div class="line-white"></div>
                <div class="left-item ">&nbsp;&nbsp;体重&nbsp;<span class="unit-span">(kg)</span></div>
                <div class="line-white"></div>
                <div class="left-item">&nbsp;&nbsp;体脂肪&nbsp;<span class="unit-span">(kg)</span></div>
                <div class="line-white"></div>
                <div class="left-item">&nbsp;&nbsp;肌肉量&nbsp;<span class="unit-span">(kg)</span></div>
                <div class="line-white"></div>
            </div>
            <!-- 第一列 -->
            <div style="width: 124px;  text-align: center;">
                <div class="left-item font-size-nomal mr">测量值</div>
                <div class=" line-white"></div>
                <div class="left-item-nomal">
                    <span class="font-size-green-bold">{{ isBodyDataNotEmpty() ? bodyData.bodyInfo.bodyWeight : ""
                        }}</span>

                </div>
                <div class="line-green"></div>
                <div class="left-item-nomal">
                    <span class="font-size-green-bold">{{ isBodyDataNotEmpty() ? bodyData.bodyInfo.valFat : "" }}</span>
                </div>
                <div class="line-green"></div>
                <div class="left-item-nomal">
                    <span class="font-size-green-bold">{{ isBodyDataNotEmpty() ? bodyData.bodyInfo.valMuscle : "" }}</span>
                </div>
                <div class="line-green"></div>
            </div>

            <!-- 第二列 -->
            <div style="width: 124px;  text-align: center;">
                <div class="left-item font-size-nomal mr">肥胖评估</div>
                <div class="line-white"></div>
                <div class="left-item-nomal">
                    <span class="font-size-green-bold">{{ isBodyDataNotEmpty() ? bodyData.bodyInfo.levelWeight : ""
                        }}</span>
                </div>
                <div class="line-green"></div>
                <div class="left-item-nomal">
                    <span class="font-size-green-bold">{{ isBodyDataNotEmpty() ? bodyData.bodyInfo.levelFat : "" }}</span>
                </div>
                <div class="line-green"></div>
                <div class="left-item-nomal">
                    <span class="font-size-green-bold">{{ isBodyDataNotEmpty() ? bodyData.bodyInfo.levelMuscle : ""
                        }}</span>
                </div>
                <div class="line-green"></div>

            </div>
            <!-- 第三列 -->
            <div style="width: 124px;  text-align: center;">
                <div class="left-item font-size-nomal mr">黄金比例</div>
                <div class="line-white"></div>
                <div class="left-item-nomal">
                    <span class="font-size-green-bold">{{ isBodyDataNotEmpty() ? bodyData.bodyInfo.targetWeight : ""
                        }}</span>
                </div>
                <div class="line-green"></div>
                <div class="left-item-nomal">
                    <span class="font-size-green-bold">{{ isBodyDataNotEmpty() ? bodyData.bodyInfo.targetFatWeight
                        : "" }}</span>
                </div>
                <div class="line-green"></div>
                <div class="left-item-nomal">
                    <span class="font-size-green-bold">{{ isBodyDataNotEmpty() ? bodyData.bodyInfo.targetMuscle : ""
                        }}</span>
                </div>
                <div class="line-green"></div>

            </div>
            <!-- 第四列 -->
            <div style="width: 124px;  text-align: center;">
                <div class="left-item font-size-nomal mr">调节量</div>
                <div class="line-white"></div>
                <div class="left-item-nomal">
                    <span class="font-size-green-bold">{{ isBodyDataNotEmpty() ? bodyData.bodyInfo.weightAdjust : ""
                        }}</span>
                </div>
                <div class="line-green"></div>
                <div class="left-item-nomal">
                    <span class="font-size-green-bold">{{ isBodyDataNotEmpty() ? bodyData.bodyInfo.fatAdjust : ""
                        }}</span>
                </div>
                <div class="line-green"></div>
                <div class="left-item-nomal">
                    <span class="font-size-green-bold">{{ isBodyDataNotEmpty() ? bodyData.bodyInfo.muscleAdjust : ""
                        }}</span>
                </div>
                <div class="line-green"></div>

            </div>

        </div>

    </div>
</template>
<script>
export default {
    data() {
        return {
        }
    },
    props: {
        bodyData: {
            type: Object,
            required: true
        }
    },
    methods: {
        isBodyDataNotEmpty() {
            return this.bodyData && Object.keys(this.bodyData).length > 0;
        }
    }
}
</script>

<style scoped>

/* 总表格横向列排列 */
.tabel-box {
    display: flex;
    flex-direction: row;
    border: 1px solid #F0F9F6;
}

/* 第一列左边tilte */
.left-item {
    font-size: 13px;
    color: #333333;
    font-weight: bold;
    height: 34px;
    line-height: 34px;
    border-left: 1px solid #F0F9F6;

}

/* item 白色块 */
.left-item-nomal {
    background: #ffffff;
    height: 34px;
    line-height: 34px;
    border-left: 1px solid #F0F9F6;
}

/* 白色下划线 */
.line-white {
    height: 1px;
    background: #F0F9F6;
}

/* 绿色下划线 */
.line-green {
    background: #F0F9F6;
    height: 1px;
}

/* 黑色不加粗 */
.font-size-nomal {
    font-weight: 400;
    font-size: 13px;
    color: #333333;
    margin-left: 4px;
}

/* 黑色不加粗 */
.font-size-bold {
    font-weight: bold;
    font-size: 13px;
    color: #333333;
}

/*绿色加粗  */
.font-size-green-bold {
    font-weight: 500;
    font-size: 13px;
    color: #333333;
}

.mr {
    margin-left: 1px;
}

.unit-span {
    font-weight: 500;
    font-size: 11px;
    color: #333333;
    line-height: 16px;
}
</style>